import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstTabService {
  mstTab: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mst_tab/list/?';
  private DeListRecord = webapi + 'mst_tab/deactivated_list/?';
  private AddRecord = webapi + 'mst_tab/create';
  private EditRecord = webapi + 'mst_tab/update';
  private GetRecord = webapi + 'mst_tab/byid/';
  private DeleteRecord = webapi + 'mst_tab/delete/';
  private ReActiveRecord = webapi + 'mst_tab/reActive/';
  private ListRecordBySectionId = webapi + 'mst_tab/gettabbysectionid/';
  private ListRecordByDsfIdSectionId = webapi + 'mst_dsf_field/gettablistbydsfidsectionid/';



    constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  reActiveRecordService(id: any) {
    return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  getTabListBySectionId(id: any) {
    return this.http.get(this.ListRecordBySectionId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  getTabListByDsfIdSectionId(dsfId: any, sectionId: any) {
    return this.http.get(this.ListRecordByDsfIdSectionId + dsfId + '/' + sectionId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-tab/mst-tab.service.ts